import { matchesAssetRopaReviewFilters } from 'config/api/assetRopa/assetRopaFilterMatchers';
import type { AssetRopaReview } from 'config/api/ropaReviews/ropaReviews.types';

import type { AssetRopaReviewFilterOptions, AssetRopaReviewFilters } from './assetRopaReview.types';
import { hasAssetWarnings } from './assetRopaReviewHelpers';

const compareStrings = (left: string, right: string) => left.localeCompare(right, undefined, { sensitivity: 'base' });

export const buildAssetRopaReviewFilterOptions = (assets: AssetRopaReview[]): AssetRopaReviewFilterOptions => {
  const assetTypeMap = new Map<number, string>();
  const ownerMap = new Map<number, string>();

  assets.forEach(asset => {
    assetTypeMap.set(asset.assetTypeId, asset.assetTypeName);
    if (asset.operationalOwnerMembershipId && asset.operationalOwnerName) {
      ownerMap.set(asset.operationalOwnerMembershipId, asset.operationalOwnerName);
    }
  });

  return {
    assetTypes: Array.from(assetTypeMap.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((left, right) => compareStrings(left.name, right.name)),
    operationalOwners: Array.from(ownerMap.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((left, right) => compareStrings(left.name, right.name)),
  };
};

export const filterAssetRopaReviews = (assets: AssetRopaReview[], filters: AssetRopaReviewFilters): AssetRopaReview[] =>
  assets.filter(asset => matchesAssetRopaReviewFilters(asset, filters, hasAssetWarnings));
